import { VolumetryCalculator, VolumetryInput } from './volumetry.interface';
import { Volumetry } from './volumetry.interface';

export const defaultVolumetryCalculator: VolumetryCalculator = (input: VolumetryInput): Volumetry[] => {
  const { segmentation, spacing, labels } = input;
  const voxelVolumeMm3 = spacing[0] * spacing[1] * spacing[2];
  
  // Count voxels per label
  const counts = new Map<number, number>();
  for (const label of segmentation) {
    if (label !== 0) {
      counts.set(label, (counts.get(label) || 0) + 1);
    }
  }
  
  // Build volumetry results
  const labelMap = new Map(labels.map(l => [l.index, l.displayName]));
  const results: Volumetry[] = [];
  
  counts.forEach((voxelCount, labelIndex) => {
    results.push({
      description: labelMap.get(labelIndex) || `Label ${labelIndex}`,
      value: (voxelCount * voxelVolumeMm3) / 1000, // mm³ to ml
      unit: 'ml',
    });
  });
  
  return results.sort((a, b) => b.value - a.value);
};